function parseIsoDate(value: string): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (match === null) {
        return null;
    }
    const year = Number(match[1]);
    const monthIndex = Number(match[2]) - 1;
    const day = Number(match[3]);
    const date = new Date(year, monthIndex, day, 12);
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== monthIndex ||
        date.getDate() !== day
    ) {
        return null;
    }
    return date;
}

export function isIsoDate(value: string): boolean {
    return parseIsoDate(value) !== null;
}

export function shiftWeek(weekStart: string, offsetWeeks: number): string {
    const date = parseIsoDate(weekStart);
    if (date === null) {
        return weekStart;
    }
    date.setDate(date.getDate() + offsetWeeks * 7);
    const pad = (part: number) => String(part).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function formatWeekLabel(
    weekStart: string | undefined,
    weekEnd: string | undefined,
): string {
    if (!weekStart || !weekEnd) {
        return 'This week';
    }
    const start = parseIsoDate(weekStart);
    const end = parseIsoDate(weekEnd);
    if (start === null || end === null) {
        return 'This week';
    }
    // week_end is exclusive; the label shows the last included day.
    end.setDate(end.getDate() - 1);
    const format = (date: Date) =>
        date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    return `${format(start)} – ${format(end)}, ${end.getFullYear()}`;
}
